import { useQuery } from '@tanstack/react-query';

interface GmailStatus {
  authenticated: boolean;
  tokenStorage: string;
  message: string;
}

async function fetchGmailStatus(): Promise<GmailStatus | null> {
  try {
    const response = await fetch('/api/auth/google/status', {
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch Gmail status:', error);
    return null;
  }
}

export function useGmailStatus() {
  const { data: status, isLoading } = useQuery({
    queryKey: ['gmailStatus'],
    queryFn: fetchGmailStatus,
    retry: false,
    // Refetch every 30 seconds to keep status up to date
    refetchInterval: 30000,
  });

  return {
    status,
    isLoading,
    isAuthenticated: status?.authenticated ?? false,
  };
}
